import publicidadService from "@/services/publicidadService";
import {
  identidadDesdeStorage,
  leerMemoria,
  estaOculta,
  marcarMostrada,
  marcarNoMostrar,
} from "@/utils/publicidadLocal";

/**
 * Publicidad de la plataforma dentro del POS.
 *
 * Carga las campañas vigentes una vez por sesión (PublicidadOverlay lo dispara al
 * loguearse), expone como máximo una por tipo y registra los eventos del usuario.
 * Nada de acá puede romper la app: si el backend falla, simplemente no hay publicidad.
 */

export const TIPOS = Object.freeze(["lanzamiento", "banner", "pos", "menu", "campana"]);

const state = () => ({
  campanias: [],
  cargado: false,
  error: null,
  // La ventana de lanzamiento se abre como máximo una vez por carga de la app
  lanzamientoMostrado: false,
});

const getters = {
  porTipo: (state) =>
    TIPOS.reduce((mapa, tipo) => {
      mapa[tipo] = state.campanias.find((campania) => campania.tipo === tipo) || null;
      return mapa;
    }, {}),
  hayCampanias: (state) => state.campanias.length > 0,
};

const mutations = {
  SET_CAMPANIAS(state, campanias) {
    state.campanias = campanias;
  },
  QUITAR(state, idCampania) {
    state.campanias = state.campanias.filter((campania) => campania.id !== idCampania);
  },
  SET_CARGADO(state, cargado) {
    state.cargado = cargado;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_LANZAMIENTO_MOSTRADO(state, mostrado) {
    state.lanzamientoMostrado = mostrado;
  },
};

function identidadActual() {
  return identidadDesdeStorage();
}

// Un evento que no se pudo registrar no es un error para el usuario
async function registrarSinRomper(idCampania, evento) {
  try {
    await publicidadService.registrarEvento(idCampania, evento);
  } catch (error) {
    // silencioso a propósito
  }
}

const actions = {
  async cargar({ commit }) {
    try {
      const campanias = await publicidadService.obtenerActivas();
      const identidad = identidadActual();
      const memoria = identidad ? leerMemoria(identidad) : { mostradas: {}, noMostrar: [] };
      const visibles = campanias.filter((campania) => !estaOculta(campania, memoria));
      commit("SET_CAMPANIAS", visibles);
      commit("SET_ERROR", null);
    } catch (error) {
      commit("SET_CAMPANIAS", []);
      commit("SET_ERROR", error.message || "No se pudo cargar la publicidad");
    } finally {
      commit("SET_CARGADO", true);
    }
  },

  async verVista(context, idCampania) {
    marcarMostrada(identidadActual(), idCampania);
    await registrarSinRomper(idCampania, "vista");
  },

  async clic(context, idCampania) {
    await registrarSinRomper(idCampania, "clic");
  },

  async cerrar({ commit }, idCampania) {
    marcarMostrada(identidadActual(), idCampania);
    commit("QUITAR", idCampania);
    await registrarSinRomper(idCampania, "cerrada");
  },

  async noMostrar({ commit }, idCampania) {
    marcarNoMostrar(identidadActual(), idCampania);
    commit("QUITAR", idCampania);
    await registrarSinRomper(idCampania, "no_mostrar");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
